import { useTranslation } from 'react-i18next'

import B2becButton from '@/components/B2becButton'
import { DeleteBorderlessIcon, DeleteIcon } from '@/components/Icons'
import useDeviceDetect from '@/hooks/useDeviceDetect'

import styles from './RemoveVoucher.module.scss'

const RemoveVoucher = ({ onRemoveVoucher, isDisabled = false }) => {
  const { t } = useTranslation()
  const { isMobile } = useDeviceDetect()

  return (
    <div className={styles.wrapper}>
      <B2becButton
        ghost
        className={styles.button}
        disabled={isDisabled}
        icon={isMobile
          ? <DeleteIcon className={styles.icon} />
          : <DeleteBorderlessIcon className={styles.icon} />}
        onClick={onRemoveVoucher}
      >
        {t('cart.removeVoucher')}
      </B2becButton>
    </div>
  )
}

export default RemoveVoucher
